import { render, staticRenderFns } from "./ForwardEmailForm.vue?vue&type=template&id=37e56822&scoped=true&"
import script from "./ForwardEmailForm.vue?vue&type=script&lang=js&"
export * from "./ForwardEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./ForwardEmailForm.vue?vue&type=style&index=0&id=37e56822&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e56822",
  null
  
)

export default component.exports